module.exports = __webpack_public_path__ + "static/media/ls.533cb320.svg";